import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useHotNotifications from 'tennders-notifications/hooks/useHotNotifications'

const GeneralLayoutTransaction = () => {
  const router = useRouter()
  const { setTransaction, fetchTransaction } = useTransaction()
  useHotNotifications()
  useEffect(() => {
    if (router?.query?.tid) {
      fetchTransaction(router.query.tid).then((response) => {
        setTransaction(response)
      })
    }
  }, [])

  return null
}

export default React.memo(GeneralLayoutTransaction)
